module.exports = __webpack_public_path__ + "static/seller/img/dy.f8311db8.png";